import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconZoomAll(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M15 3C14.4477 3 14 3.44772 14 4C14 4.55228 14.4477 5 15 5H17.5858L13.2929 9.29289C12.9024 9.68342 12.9024 10.3166 13.2929 10.7071C13.6834 11.0976 14.3166 11.0976 14.7071 10.7071L19 6.41421V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 3.44772 20.5523 3 20 3H15Z"
        fill="currentColor"
      />
      <path
        d="M9 21C9.55228 21 10 20.5523 10 20C10 19.4477 9.55228 19 9 19H6.41421L10.7071 14.7071C11.0976 14.3166 11.0976 13.6834 10.7071 13.2929C10.3166 12.9024 9.68342 12.9024 9.29289 13.2929L5 17.5858L5 15C5 14.4477 4.55228 14 4 14C3.44772 14 3 14.4477 3 15L3 20C3 20.5523 3.44772 21 4 21H9Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
